export {
    canAddToCart,
    getMaxSelectableQty,
    getPurchasableOffer,
    isQtyValid,
    parseAvailabilityStatus,
    resolveOfferAvailability,
    sanitizeMultiple,
    toOfferSignals,
    toSchemaAvailability,
} from './resolveOfferAvailability';

export type { AvailabilityFields, SchemaOfferAvailability } from './types';
